<template>
  <div>
    <el-row :gutter="20">
      <el-form label-width="80px"
               :inline="true"
               :model="reportForm">

        <el-form-item label="代理商">
          <el-select v-model="reportForm.proxyCode"
                     @change="getReportList(1)"
                     clearable
                     placeholder="代理商">
            <el-option label="云天弈"
                       value="yuntianyi"></el-option>
            <template v-for="item in proxyPageInfo.records">
              <el-option :key="item.id"
                         :label="item.proxyName"
                         :value="item.proxyCode"></el-option>
            </template>
          </el-select>
        </el-form-item>

        <el-form-item label="报告时间">
          <el-date-picker v-model="reportForm.dateRange"
                          @change="getReportList(1)"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-row>
          <el-table v-loading="tableLoading"
                    :data="pageInfo.records"
                    style="width: 100%">
            <el-table-column label="学校名称">
              <template slot-scope="scope">
                {{scope.row.schoolName || '云天弈'}}
              </template>
            </el-table-column>
            <el-table-column label="代理商">
              <template slot-scope="scope">
                {{scope.row.proxyName || '云天弈'}}
              </template>
            </el-table-column>
            <el-table-column prop="username"
                             label="姓名">
            </el-table-column>
            <el-table-column prop="names"
                             label="股票名称">
            </el-table-column>
            <el-table-column label="创建时间">
              <template slot-scope="scope">
                {{scope.row.createTime}}
              </template>
            </el-table-column>

            <el-table-column label="报告类型">
              <template slot-scope="scope">
                {{scope.row.reportType | reportTypeFilter}}
              </template>
            </el-table-column>
            <el-table-column prop="fileType"
                             label="文件类型">
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                {{scope.row.status | statusFilter}}
              </template>
            </el-table-column>
            <el-table-column label="操作"
                             width="140">
              <template slot-scope="scope">
                <el-button type="text"
                           @click="reGenReport(scope.row.sourceId)"
                           size="small">重新生成</el-button>

                <el-link :href="'/api/web/admin/readPdf/' + scope.row.sourceId"
                         target="_blank"
                         :underline="false"> 阅读</el-link>

              </template>
            </el-table-column>

          </el-table>
        </el-row>
        <el-row>
          <el-pagination background
                         layout="prev, pager, next"
                         @current-change="getReportList"
                         :total="pageInfo.total">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import axios from 'axios'
import moment from 'moment'
export default {
  name: 'myReports',
  data: function () {
    return {
      tableLoading: true,

      reportForm: {
        dateRange: [new Date(), new Date()],
        proxyCode: ''
      },

      sourceId: '',

      pageInfo: {
        current: 1,
        size: 10,
        records: [],
        total: 1
      },

      options: [],

      proxyPageInfo: {
        records: []
      }
    }
  },
  filters: {
    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    },

    reportTypeFilter: function (v) {
      switch (v) {
        case 'ALL':
          return '所有'
        case 'FULL':
          return '个股分析（增强版）'
        case 'SIMPLE':
          return '个股分析'
        case 'TINY':
          return '个股分析简报'
        case 'CONCEPT':
          return '概念报告'
        case 'COMPARE':
          return '投资组合'
        case 'FINANCE':
          return '财务报告'
        case 'HKSTOCK':
          return '香港个股'
        default:
          break
      }
      return v
    },
    statusFilter: function (v) {
      switch (v) {
        case 'FAIL':
          return '失败'
        case 'FINISH':
          return '完成'
        case 'DOING':
          return '生成中'
        default:
          return v
      }
    },
    fileTypeFilter: function (v) {
      switch (v) {
        case 'PDF':
          return 'PDF'
        case 'DOC':
          return 'WORD'
        case 'ALL':
          return '所有'

        default:
          return v
      }
    },
    rolesTypeFilter: function (v) {
      switch (v) {
        case 'ADMIN':
          return '管理员'
        case 'NORMAL':
          return '注册用户'
        case 'VIP':
          return 'VIP用户'
        case 'SVIP':
          return '超级VIP'
        default:
          return v
      }
    }
  },
  methods: {
    getProxyList () {
      let _this = this
      axios.get('/api/web/admin/proxyList?page=1&pageSize=1000').then(resp => {
        _this.proxyPageInfo = resp.data
      })
    },

    reGenReport (sourceId) {
      if (sourceId) {
        let _this = this
        axios.get('/api/web/admin/reGenReport/' + sourceId).then(resp => {
          _this.$message({
            message: '任务提交成功',
            type: 'success'
          })
        })
      }
    },
    getReportList (i) {
      let _this = this
      _this.pageInfo = {}
      axios.get('/api/web/admin/reportList?page=' + i + '&startDate=' + moment(this.reportForm.dateRange[0]).format('YYYY-MM-DD') + '&endDate=' + moment(this.reportForm.dateRange[1]).format('YYYY-MM-DD') + '&proxyCode=' + this.reportForm.proxyCode).then(resp => {
        _this.tableLoading = false
        _this.pageInfo = resp.data
        _this.pageInfo.total = parseInt(resp.data.total)
      })
    }
  },
  components: {

  },
  mounted () {
    this.getReportList(1)
    this.getProxyList()
  },
  watch: {

  }
}
</script>
<style scope>
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/report.vue